<template>
  <div class="tw-transition tw-border tw-border-gray dark:tw-border-dm-gray tw-rounded-2xl tw-bg-light dark:tw-bg-dm-light">
    <div class="tw-flex tw-p-4 tw-items-center tw-justify-between">
      <div class="tw-flex">
        <div
          class="tw-flex-shrink-0 tw-w-8 tw-h-8 tw-rounded-full tw-mr-3 tw-flex tw-items-center tw-justify-center tw-font-medium"
          :class="getStatusHumanOrderClasses()"
        >
          <icon-check
            v-if="isCompleted && !status.is_current"
            class="tw-w-4"
          />
          <span v-else>
            {{ status.human_order }}
          </span>
        </div>
        <span class="tw-text-xl tw-font-bold tw-tracking-wide">
          {{ status.status_type_name }}
        </span>
      </div>
      <el-switch
        v-if="!isObtained && $isInRole(['ADMIN', 'CONSULTANT'])"
        :model-value="status.is_current"
        :active-text="$t('foreigners.permits.current_status')"
        class="tw-flex-row-reverse tw-gap-2"
        :class="[
          status.is_current ? 'tw-opacity-100' : ''
        ]"
        :disabled="status.is_current"
        @change="$emit('change-current-status', status, !status.is_current)"
        @click.native.stop
      />
    </div>
    <div class="tw-p-4 tw-pt-0 tw-flex tw-flex-col tw-gap-4">
      <PermitStatusActionDate
        v-for="actionDate in status.action_dates"
        :key="actionDate.id"
        :permit="permit"
        :status-id="status.id"
        :action-date="actionDate"
        :is-obtained="isObtained"
        @update="(payload) => updateActionDate(payload)"
      />
    </div>
  </div>
</template>

<script>
import PermitStatusActionDate from '@/components/Permits/PermitStatusActionDate.vue';
import eventBus from '../../plugins/eventBus';

export default {
  components: {
    PermitStatusActionDate,
  },
  props: {
    status: {
      type: Object,
      required: true,
    },
    permit: {
      type: Object,
      required: true,
    },
    isCompleted: {
      type: Boolean,
      default: false,
    },
    isObtained: {
      type: Boolean,
      default: false,
    },
    currentStatus: {
      type: Object,
      required: true,
    },
  },
  mounted() {
    eventBus.on('collapse-status', this.handleSave);
  },
  beforeUnmount() {
    eventBus.off('collapse-status', this.handleSave);
  },
  methods: {
    handleSave(permitStatusId) {
      if (permitStatusId === this.status.id) {
        eventBus.emit('save', this.status.id);
      }
    },
    updateActionDate(payload) {
      const updatedStatus = {
        ...this.status,
        isUpdated: true,
        action_dates: this.status.action_dates.map((actionDate) => {
          if (actionDate.id === payload.id) {
            return {
              ...actionDate,
              ...payload,
            };
          }
          return actionDate;
        }),
      };

      this.$store.commit('v2/admin/foreigners/foreigner/update', ['permitStatusesUpdateDraft', {
        id: this.status.id,
        payload: updatedStatus,
      }]);
    },
    getStatusHumanOrderClasses() {
      if (this.currentStatus?.human_order > this.status.human_order || this.isObtained) {
        return 'tw-bg-universal tw-text-white';
      }
      if (this.currentStatus?.human_order === this.status.human_order) {
        return 'tw-bg-primary tw-text-white';
      }
      if (this.currentStatus?.human_order < this.status.human_order) {
        return 'tw-bg-white tw-text-status-upcoming';
      }
    },
  },
};
</script>
